<template>
	<div class="ca-trends">

		<h3 class="title title-page text-primary font-medium">Analyse des tendances</h3>
        <md-card>
            <md-card-header class="md-card-header-icon md-card-header-blue">
                <div class="card-icon">
                    <font-awesome-icon class="md-icon" :icon="['fa', 'poll']" />
                </div>
                <h4 class="title font-normal">Analyse des tendances</h4>
            </md-card-header>
            <md-card-content>
                <div v-for="site in sites" :key="site.id" class="mb-1">
                    <h4 class="font-normal text-base mb-0">{{ site.name }}</h4>

	                <div class="flex items-center space-x-2">
		                <template v-for="(year, key) in years">
			                <pdf-trend-button :year="year" :siteId="site.id" :key="key"></pdf-trend-button>
		                </template>
	                </div>
                </div>
            </md-card-content>
        </md-card>
	</div>
</template>

<script>
import PdfTrendButton from "../../../components/ClientsArea/Trends/PdfTrendButton";

export default {
	name: "ClientsAreaTrends",
	components: {
		PdfTrendButton
	},
	data() {
		return {
			sites: [],
		}
	},
    computed: {
        years () {
            let firstYear = this.$moment('2019-01-01').year()
            let currentYear = this.$moment().year()
            let years = []
            let year = firstYear
            while (year <= currentYear) {
                years.push(year.toString())
                year++
            }
            return years
        }
    },
    methods: {
	    async fetchTrends() {
            const localStorageData = JSON.parse(localStorage.getItem('client-area'))
            const { data } = await this.$store.dispatch('clientArea/fetchTrends', {
                    access_token: localStorageData.accessToken,
                    user_type: localStorageData.userType,
                }
            );
            this.sites = data
        },
    },
    mounted() {
        this.fetchTrends()
    }
}
</script>

<style scoped>
.title-page {
	margin: .25rem 15px;
	padding: .25rem 0;
}
</style>
